import type { OpenAPIV3_1 as OpenApi3 } from 'openapi-types'

import { logger } from '@subaio/utils'

import { asContainer } from 'lib/container'

import { Doc } from 'components/Layout'
import { OpenApi } from 'components/OpenApi'

type Params = {
	mrIid: string
	scope: string
	apiName: string
	version: string
}

type State = {
	apiDocument?: OpenApi3.Document
}

export const container = asContainer<State, Params>()({
	path: '/internal/apis/viewer/:mrIid/:scope/:apiName/:version',
	title: 'View API spec',
	authentication: { type: 'public' },
	initialize: async ({ mrIid, scope, apiName, version }) => {
		try {
			const response = await fetch(
				`/api/internal/review/${encodeURIComponent(mrIid)}/${encodeURIComponent(scope)}/${encodeURIComponent(apiName)}/${encodeURIComponent(version)}`,
				{ cache: 'no-cache' },
			)

			if (!response.ok) {
				throw new Error((await response.text()) || `The API spec could not be loaded (HTTP ${response.status}).`)
			}

			return { apiDocument: (await response.json()) as OpenApi3.Document }
		} catch (error) {
			logger.error(error)
			return {}
		}
	},
	Running: ({ apiDocument, statuspageApi }) => {
		if (apiDocument) {
			return <OpenApi apiDocument={apiDocument} statuspageApi={statuspageApi} />
		}

		return (
			<Doc showTableOfContents={false}>
				<div>
					<p>The API spec could not be loaded</p>
				</div>
			</Doc>
		)
	},
})
